import {
    GET_SCHEDULES,
    GET_SCHEDULES_SUCCESS,
    GET_SCHEDULES_DATA_ERROR,
    CLEAR_SCHEDULES_STATE,
    SET_SCHEDULE,
    GET_PAGINATION_SCHEDULES,
    CREATE_SCHEDULES,
    CREATE_SCHEDULES_SUCCESS,
    CREATE_SCHEDULES_FAIL,
    UPDATE_SCHEDULES,
    UPDATE_SCHEDULES_SUCCESS,
    UPDATE_SCHEDULES_FAIL,
    DELETE_SCHEDULES,
    DELETE_SCHEDULES_SUCCESS,
    GET_SCHEDULE_COMMANDS,
    GET_SCHEDULE_COMMANDS_SUCCESS
} from "./actionTypes";

export const getSchedules = (params) => ({
    type: GET_SCHEDULES,
    filters: {...params}
});

export const getSchedulesSuccess = (data) => ({
    type: GET_SCHEDULES_SUCCESS,
    payload: data
});

export const getScheduleCommands = () => ({
    type: GET_SCHEDULE_COMMANDS,
});

export const getScheduleCommandsSuccess = (data) => ({
    type: GET_SCHEDULE_COMMANDS_SUCCESS,
    payload: data
});

export const createSchedules = schedule => ({
    type: CREATE_SCHEDULES,
    payload: schedule
});

export const createSchedulesSuccess = schedule => ({
    type: CREATE_SCHEDULES_SUCCESS,
    payload: schedule,
});

export const createSchedulesFail = error => ({
    type: CREATE_SCHEDULES_FAIL,
    payload: error,
})

export const updateSchedule = (schedule, schedule_id) => ({
    type: UPDATE_SCHEDULES,
    payload: {schedule, schedule_id}
});

export const updateScheduleSuccess = schedule => ({
    type: UPDATE_SCHEDULES_SUCCESS,
    payload: schedule,
});

export const updateScheduleFail = error => ({
    type: UPDATE_SCHEDULES_FAIL,
    payload: error,
});

export const deleteSchedule = (schedule_id) => ({
    type: DELETE_SCHEDULES,
    payload: {schedule_id}
});

export const deleteScheduleSuccess = (id) => ({
    type: DELETE_SCHEDULES_SUCCESS,
    payload: id
});


export const setSchedule = (schedule) => ({
    type: SET_SCHEDULE,
    payload: schedule
});

export const setPagination = pagination => ({
    type: GET_PAGINATION_SCHEDULES,
    payload: pagination,
});

export const dataError = error => ({
    type: GET_SCHEDULES_DATA_ERROR,
    payload: error,
});

export const clearState = (state) => ({
    type: CLEAR_SCHEDULES_STATE,
    payload: state
});
